import { skipToken } from '@tanstack/react-query'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { trpc } from '@viastud/ui/lib/trpc'

import { OnboardingCreateAccount } from '@/components/onboarding/onboarding-create-account.tsx'
import { useAuthStore } from '@/store/auth.store'
import { useOnBoardingStore } from '@/store/onboarding.store'

export const Route = createFileRoute('/_student/onboarding')({
  component: Onboarding,
})

const TOTAL_ONBOARDING_STEPS = 1

const getProgressPercent = (page: number) => {
  return Math.min(100, Math.round((page / TOTAL_ONBOARDING_STEPS) * 100))
}

function Onboarding() {
  const { page } = useOnBoardingStore()
  const auth = useAuthStore()
  const navigate = useNavigate()

  //1. get if user is already login
  const userId = auth.role === 'STUDENT' ? auth.user?.id : undefined
  const { data } = trpc.user.getUserDetails.useQuery(userId ? { id: userId } : skipToken)
  if (data?.isFinished) {
    void navigate({ to: '/' })
  }

  const progressPercent = getProgressPercent(page)

  return (
    <div className="relative flex h-screen w-screen items-center justify-center">
      <div className="absolute left-0 top-0 z-40 h-2 w-full bg-blue-200"></div>
      <div
        className="absolute left-0 top-0 z-50 h-2 rounded-r-full transition-all duration-300 ease-out"
        style={{
          width: `${progressPercent}%`,
          background: '#343BFF',
        }}
      ></div>
      <OnboardingCreateAccount />
    </div>
  )
}
